<template>
  <v-card flat>
    <v-bottom-nav :active.sync="bottomNav" :value="true" app :color="bottombar.back">
      <v-btn class="btnMenuInferior" :color="bottombar.btn" flat value="home" @click.stop="$emit('clique-em-home')"><!-- $emit('alternar-content','home') -->
        <span>Home</span>
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn class="btnMenuInferior"  :color="bottombar.btn" flat value="sobre" @click="$emit('click-dialog-sobre')" v-if="tamanhoSobre>0">
        <span>Sobre</span>
        <v-icon>info</v-icon>
      </v-btn>

      <v-btn class="btnMenuInferior" v-if="qtdItensPedido>0" :color="bottombar.btn" flat value="pedidos" @click.stop="$emit('abrir-dialog-pedido')">
        <span>Pedido</span>
        <v-badge color="cyan" right>
          <template v-slot:badge>
            <span>{{qtdItensPedido}}</span>
          </template>
          <v-icon>shopping_cart</v-icon>
        </v-badge>
      </v-btn>
      <v-btn disabled flat icon v-else>
        <span>Pedido</span>
        <v-icon>shopping_cart</v-icon>
      </v-btn>

      <v-btn class="btnMenuInferior" :color="bottombar.btn" flat value="conta" @click="$emit('abrir-dialog-user')">
        <span>Conta</span>
        <v-icon>person</v-icon>
      </v-btn>

    </v-bottom-nav>
  </v-card>
</template>
<script>
export default {
  props: ["qtdItensPedido","bottombar","tamanhoSobre"],
  data() {
    return {
      bottomNav: "home"
    };
  }
};
</script>
<style>
.btnMenuInferior {
  min-width: 53px!important;
}
</style>
